"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="cs">
      <body className="bg-paper text-ink">
        <section className="section-y">
          <div className="container-page">
            <h1 className="text-h2 font-display font-light text-ink">
              Něco se pokazilo
            </h1>
            <p className="prose-lead mt-5">
              Načtení stránky selhalo. Zkuste to prosím znovu.
            </p>
            <button
              type="button"
              onClick={reset}
              className="mt-8 inline-flex min-h-12 items-center justify-center rounded-xs bg-clay px-6 font-sans text-sm font-medium text-paper"
            >
              Zkusit znovu
            </button>
          </div>
        </section>
      </body>
    </html>
  );
}
